import { render } from "./CreateVerseOfTheDayView.vue?vue&type=template&id=6aeb3e66"
import script from "./CreateVerseOfTheDayView.vue?vue&type=script&lang=js"
export * from "./CreateVerseOfTheDayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__